// CRM E-I / E-IV: Aktivitäten aus dem Browser anlegen.
//
// `Activities` trägt Field-Level-`@auth` an `userId`, `companyOwnerUserId` und
// `leadShare` — und zwar mit `create` für die Vertriebsrollen (S-0 Prüfung 6). Genau
// deshalb ist Anlegen aus dem Browser möglich, `update` auf diese drei Felder aber
// nicht. Die drei Felder MÜSSEN beim Anlegen mitkommen: ohne sie ist die Aktivität für
// den Zuständigen der Firma unsichtbar, obwohl sie an seiner Firma hängt.

export const createActivities = /* GraphQL */ `
  mutation CreateActivities($input: CreateActivitiesInput!) {
    createActivities(input: $input) {
      id
      activityType
      subject
      body
      occurredAt
      outcome
      durationSeconds
      companyID
      contactPersonId
      taskID
      objectID
      objectType
      # Anhaenge, denormalisiert am Datensatz (Documents ohne @hasMany, siehe Schema) — kein
      # @hasMany, die API ist am Ressourcenlimit.
      documents {
        id
        name
        fileType
        type
      }
    }
  }
`;

// E-I / E-IV: die Gegenrichtung. Die neue Aktivität wird an `Tasks.activityIDs`
// ANGEHÄNGT — ein Auftrag kann mehrere Anrufe kosten, und alle bleiben verknüpft.
// Erledigt wird die Aufgabe nur, wenn der Anrufer jemanden erreicht hat
// (`complete` in linkTaskActivity). Sie wird NICHT gelöscht und nicht inhaltlich geändert —
// sie bleibt in der Aufgabenliste stehen, der Verlauf zeigt nur nicht beides doppelt
// (G3, findPartner in activityLinks.js).
export const updateTaskAfterActivity = /* GraphQL */ `
  mutation UpdateTasks($input: UpdateTasksInput!) {
    updateTasks(input: $input) {
      id
      status
      completedAt
      activityIDs
      originActivityID
    }
  }
`;

// Der Stand der Liste unmittelbar vor dem Anhängen. Ein Feld, eine Abfrage — und damit
// kann `Tasks.activityIDs` nicht mehr auseinanderlaufen, wenn dieselbe Aufgabe zweimal
// ohne Neuladen bearbeitet wird (zweiter Anruf auf denselben Auftrag ist der Regelfall,
// um den es hier geht).
export const getTaskActivityIDs = /* GraphQL */ `
  query GetTasks($id: ID!) {
    getTasks(id: $id) {
      id
      activityIDs
    }
  }
`;

// Zustand der Firma für die drei Auth-Felder. `type` entscheidet über `leadShare`:
// an einem Lead darf jeder Sales-User, an einem Kunden nur der Zuständige (A-V Punkt 22).
export const getCompanyActivityContext = /* GraphQL */ `
  query GetCompanyActivityContext($id: ID!) {
    getCompanies(id: $id) {
      id
      type
      contactPersonUserId
    }
  }
`;

// E-V: eine bestehende Aktivität aus dem Verlauf heraus korrigieren.
//
// Die drei Auth-Felder (userId, companyOwnerUserId, leadShare) stehen bewusst NICHT im
// Input: die Vertriebsrollen haben auf ihnen nur create und read (S-0 Prüfung 6), ein
// Mitschicken endete als "Unauthorized on userId". Und kein null in irgendeinem Feld —
// bei Field-Level-@auth ist `nullAllowedFields` leer (CLAUDE.md).
export const updateActivity = /* GraphQL */ `
  mutation UpdateActivities($input: UpdateActivitiesInput!) {
    updateActivities(input: $input) {
      id
      activityType
      subject
      body
      occurredAt
      outcome
      durationSeconds
      location
      endsAt
      direction
      phoneNumber
      companyID
      contactPersonId
      taskID
      objectID
      objectType
      # Anhaenge, denormalisiert am Datensatz (Documents ohne @hasMany, siehe Schema) — kein
      # @hasMany, die API ist am Ressourcenlimit.
      documents {
        id
        name
        fileType
        type
      }
    }
  }
`;

// Eine Aktivitaet zum Bearbeiten nachladen — fuer den Sprung "Zur Aktivitaet" von der
// Aufgabe aus. Dieselben Felder, die ActivityEditModal liest und zurueckschreibt.
export const getActivityForEdit = /* GraphQL */ `
  query GetActivities($id: ID!) {
    getActivities(id: $id) {
      id
      activityType
      subject
      body
      occurredAt
      outcome
      durationSeconds
      location
      endsAt
      direction
      phoneNumber
      companyID
      contactPersonId
      taskID
      objectID
      objectType
      # Anhaenge, denormalisiert am Datensatz (Documents ohne @hasMany, siehe Schema) — kein
      # @hasMany, die API ist am Ressourcenlimit.
      documents {
        id
        name
        fileType
        type
      }
    }
  }
`;
